// Static icon component for sidebar to avoid DynamicIcon performance issues
// All icons are imported statically at build time

import React, { memo } from "react";
import {
  Home,
  Coins,
  PieChart,
  Globe,
  Target,
  BarChart2,
  Users,
  Newspaper,
  LayoutDashboard,
  Wallet,
  Sparkles,
  ScanSearch,
  LineChart,
  TrendingUp,
  BarChartHorizontalBig,
  Bookmark,
  Bell,
  Grid2x2,
  Percent,
  GitMerge,
  Banknote,
  Circle,
  Twitter,
  Youtube,
  Package,
  Table,
  Table2,
  type LucideIcon,
} from "lucide-react";

// Map icon names to static imports
// Only includes icons used in the sidebar navigation
const SIDEBAR_ICONS: Record<string, LucideIcon> = {
  // Main navigation groups
  "home": Home,
  "coins": Coins,
  "pie-chart": PieChart,
  "globe": Globe,
  "target": Target,
  "bar-chart-2": BarChart2,
  "users": Users,
  "newspaper": Newspaper,
  "layout-dashboard": LayoutDashboard,
  "wallet": Wallet,
  "sparkles": Sparkles,

  // Sub-items
  "scan-search": ScanSearch,
  "line-chart": LineChart,
  "trending-up": TrendingUp,
  "bar-chart-horizontal-big": BarChartHorizontalBig,
  "bookmark": Bookmark,
  "bell": Bell,
  "grid-2x2": Grid2x2,
  "percent": Percent,
  "git-merge": GitMerge,
  "banknote": Banknote,

  // Social & News
  "twitter": Twitter,
  "youtube": Youtube,
  "package": Package,

  // Workspace
  "table": Table,
  "table-2": Table2,

  // Fallback
  "circle": Circle,
  "dot": Circle,
};

interface SidebarIconProps {
  name: string;
  className?: string;
}

/**
 * Static sidebar icon component
 * Uses pre-imported icons instead of DynamicIcon to prevent main thread blocking
 */
const SidebarIcon: React.FC<SidebarIconProps> = ({ name, className = "" }) => {
  const IconComponent = SIDEBAR_ICONS[name] ?? Circle;
  return <IconComponent className={className} />;
};

export default memo(SidebarIcon);
